module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAKBAMAAABPkMOvAAAAHlBMVEUAAABFSUtFR0lFRkr///9FR0lFR0pGTU1ISFBERkn2u5+gAAAACXRSTlMAN/GbAeJmISDzeTSSAAAARklEQVQI12MAAtFABjBg1JwkAGYIzZypCBGYbAkUAgmYOAOFQAIOLEAhkAADA0gocrIDAwOL5VSGTKAAUGgaAwdQAChUAAA9TQ30fRmVhQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/up.png
// module id = XtJf
// module chunks = 3